import { inject, Injectable } from '@angular/core';
import { CrmModalService } from 'common-module/modal';
import { ConfirmActionModalComponent } from '@app/shared/components/confirm-action-modal/confirm-action-modal.component';

@Injectable({ providedIn: 'root' })
export class PlcardModalService {
  private modalService = inject(CrmModalService);

  public createConfirmUploadModal(onOk: () => void, onCancel?: () => void): void {
    const modal = this.modalService.create({
      nzTitle: undefined,
      nzFooter: null,
      nzWidth: 620,
      nzNoAnimation: true,
      nzContent: ConfirmActionModalComponent,
      nzData: {
        title: 'modal.confirmUpload.title',
        body: 'modal.confirmUpload.content',
        confirmText: 'modal.confirmUpload.actions.confirm',
        cancelText: 'modal.confirmUpload.actions.cancel',
        confirmButtonStyle: {
          'background-color': '#ef9c53',
          border: '1px solid #ef9c53',
          color: 'white'
        },
        handleConfirmClick: () => {
          onOk();
          modal.close();
        },
        handleCancelClick: () => {
          if (onCancel) {
            onCancel();
          }
          modal.close();
        }
      } as Partial<ConfirmActionModalComponent>
    });
  }
}
